<template>
  <v-container>
    <!--//@*/*
    //    *RPD  Nbirs test App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <!-- coding div -->

    <!-- Question1 -->
    <v-row id="s4q1" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 1</v-card-title>
          <v-card-subtitle class="pb-0"
            >An unknown suspect breaks into a vehicle and rifles through all the
            property in the vehicle, but nothing is actually stolen. The report
            should be coded as:</v-card-subtitle
          >
          <v-radio-group v-model="local_s4answers.s4q1" class="ml-8 mt-0">
            <v-radio
              label="Theft from a motor vehicle - completed"
              value="s4q1-1"
            ></v-radio>
            <v-radio
              label="Theft from a motor vehicle - attempted"
              value="s4q1-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question2 -->
    <v-row id="s4q2" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 2</v-card-title>
          <v-card-subtitle class="pb-0"
            >Police investigate a domestic disturbance where both the parties
            involved have redness but no major injuries. The officer can not
            determine a primary physical aggressor.</v-card-subtitle
          >
          <v-radio-group v-model="local_s4answers.s4q2" class="ml-8 mt-0">
            <v-radio
              label="Complete the report showing one offender and one victim"
              value="s4q2-1"
            ></v-radio>
            <v-radio
              label="Complete the report showing both subjects as both offender and victim"
              value="s4q2-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 3 -->
    <v-row id="s4q3" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 3</v-card-title>
          <v-card-subtitle class="pb-0"
            >In the example above, assume the parties' names are John and Jane.
            While linking the relationships, John should be listed
            as:</v-card-subtitle
          >
          <v-radio-group v-model="local_s4answers.s4q3" class="ml-8 mt-0">
            <v-radio
              label="BG to show his relationship to Jane and SE to show his relationship to himself"
              value="s4q3-1"
            ></v-radio>
            <v-radio
              label="BG to show his relationship to Jane and VO to show his relationship to himself"
              value="s4q3-2"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 4 -->
    <v-row id="s4q4" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 4</v-card-title>
          <v-card-subtitle class="pb-0">
            Hate crimes are reported to NIBRS on the BIAS tab. What number means
            there was no bias motivating the attacker.</v-card-subtitle
          >
          <v-radio-group v-model="local_s4answers.s4q4" class="ml-8 mt-0">
            <v-radio label="02" value="s4q4-1"></v-radio>
            <v-radio label="88" value="s4q4-2"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 5 -->
    <v-row id="s4q5" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 5</v-card-title>
          <v-card-subtitle class="pb-0"
            >All completed property crimes MUST be coded correctly and have an
            accurate value attached.</v-card-subtitle
          >
          <v-radio-group v-model="local_s4answers.s4q5" class="ml-8 mt-0">
            <v-radio label="True" value="s4q5-1"></v-radio>
            <v-radio label="False" value="s4q5-2"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 6 -->
    <v-row id="s4q6" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 6</v-card-title>
          <v-card-subtitle class="pb-0"
            >NIBRS has a definition of “unknown” assigned when a property value
            is listed as $1.00.</v-card-subtitle
          >
          <v-radio-group v-model="local_s4answers.s4q6" class="ml-8 mt-0">
            <v-radio label="True" value="s4q6-1"></v-radio>
            <v-radio label="False" value="s4q6-2"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 7 -->
    <v-row id="s4q7" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 7</v-card-title>
          <v-card-subtitle class="pb-0"
            >During a drug arrest, all the arrested persons are White Males, the
            BIAS tab should reflect:</v-card-subtitle
          >
          <v-radio-group v-model="local_s4answers.s4q7" class="ml-8 mt-0">
            <v-radio label="88 - no Bias" value="s4q7-1"></v-radio>
            <v-radio label="11 - anti-White" value="s4q7-2"> </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>

    <!-- Question 8 -->
    <v-row id="s4q8" class="pt-0">
      <v-col cols="12" class="d-flex justify-center">
        <v-card elevation="2" outlined shaped class="mt-1 pt-0 fixWidth">
          <v-card-title>Question 8</v-card-title>
          <v-card-subtitle class="pb-0"
            >Under the BIAS tab, 99 is an acceptable value.</v-card-subtitle
          >
          <v-radio-group v-model="local_s4answers.s4q8" class="ml-8 mt-0">
            <v-radio
              label="No it only goes up to 88"
              value="s4q8-1"
              @click.prevent="ScoreButtonOn"
            ></v-radio>
            <v-radio
              label="Yes, 99 means Unknown if there was a bias"
              value="s4q8-2"
              @click.prevent="ScoreButtonOn"
            >
            </v-radio>
          </v-radio-group>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #home-container {
    width: 100%;
    max-width: 768px;
    height: auto;
    padding-top: 65px;
    margin: auto;
  }

  #home-container .v-card__subtitle {
    color: #5c5c5c;
  }

  #home-container a {
    color: #1565c0;
  }

  #home-container a.temp-2-nav {
    color: aliceblue;
  }

  .fixWidth {
    width: 100%;
  }

  .fixWidth_header {
    width: 100%;
  }

  .rad1 {
    background-color: white;
    height: 250px;
    width: 80%;
  }

  .alice {
    color: aliceblue;
  }

  .v-card__subtitle.reference {
    color: blue;
  }

  #sworn_test_section1 .top-card,
  #sworn_test_section2 .top-card,
  #section3-header .top-card {
    background-color: #324e96;
  }

  .coding {
    font-size: medium;
    text-align: center;
  }

  .noWordWrap {
    white-space: nowrap;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  #home-container {
    width: 100%;
    max-width: 768px;
  }
}

@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .fixWidth {
    width: 80%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  #home-container {
    width: 100%;
    max-width: 768px;
  }

  .fixWidth {
    width: 80%;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
  #home-container {
    width: 100%;
    max-width: 768px;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "section4",
  mixins: [bus_common],
  props: ["session", "s4answers"],
  data() {
    return {
      bFirstUpdate: false,
      local_s4answers: {},

      search: "",
      /* pages: [
        { id: 1, pg: "0", src: "./question_images/s2q1.png" },
        { id: 2, pg: "5", src: "./question_images/s2q2.png" },
        { id: 3, pg: "8", src: "./question_images/s2q3.png" },
        { id: 4, pg: "9", src: "./question_images/s2q4.png" },
        { id: 5, pg: "9", src: "./question_images/s2q5.png" },
        { id: 6, pg: "15", src: "./question_images/s2q6.png" },
        { id: 7, pg: "15", src: "./question_images/s2q7.png" },
        { id: 8, pg: "8 & 9", src: "./question_images/s2q8.png" },
        { id: 9, pg: "8 & 9", src: "./question_images/s2q9.png" },
        { id: 10, pg: "8 & 9", src: "./question_images/s2q10.png" },
        { id: 11, pg: "8 & 9", src: "./question_images/s2q11.png" },
        {
          id: 12,
          pg: "Tiburon Screenshot",
          src: "./question_images/tiburon_screen_750.png",
        },
      ], */
      bReadyToUpdate: false,
    };
  },
  watch: {
    local_s4answers: {
      deep: true,
      handler() {
        this.update_answers();
      },
    },
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    ScoreButtonOn() {
      this.$emit("ScoreButtonOn");
    },
    update_answers() {
      if (this.bReadyToUpdate) {
        this.$emit("update_answers", this.local_s4answers);
      }
    },
    init() {
      var self = this;
      setTimeout(function () {
        self.local_s4answers = self.mno(self.s4answers);
        //   this.local_q17Form = this.mno(this.q17Form);
        self.$nextTick(() => {
          self.bReadyToUpdate = true;
        });
      }, 5000);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
